$('.logo-box').hide()

// 首页 home-name
const home = `<div class="nav-item">
              <a id="home-name" href="index.html?idx=0"></a>
              </div>
            <div class="nav-line" id="navLine"></div>`;
$("#nav").append(home);

$.ajax({
	url: '/api/admin/official/exc/newNavigationBar?type=2',
	type: 'GET',
	dataType: 'json',
	success: function (data) {
		const list = data.data || []
		let that = this
		const tabId = ''
		that.tabId = data.data
		let contents = ''
		// let contents = `<div class="nav-item">
		//                 <a id="home-name" href="index.html?idx=0"></a>
		//                 </div>
		//               <div class="nav-line" id="navLine"></div>`
		let url = ''
		let aTagTarget = '_self'
		let footerList = ''
		$.each(list, function (i) {
			const ids = list[i].optionsId
			const navId = list[i].optionsId
			const name = list[i].optionsName
			// const idx = list[i].sort
			const idx = i + 1
			const title = list[i].name
			if (list[i].iconUrl === "") {
				list[i].iconUrl = "/static/images/bg-icon.jpg"
			}
			const bg = list[i].iconUrl

			// 列表 optionsId = 2：资讯详情 4：会员单位
			// if(idx === 1 && list[i].typeOptionsId === 1) {
			//   url = `aboutUs.html?idx=${idx}&id=${ids}&bg=${bg}`
			// } else 
			if (list[i].typeOptionsId === 2) {
				url = `memberDetail.html?idx=${idx}&id=${ids}&bg=${bg}`
			} else if (list[i].typeOptionsId === 4) {
				url = `memberUnit.html?idx=${idx}&bg=${bg}`
			} else if (list[i].typeOptionsId === 7) {
				aTagTarget = '_blank'
				url = list[i].linkUrl
			}
			// else if(ids === '3') {
			//   url = `aboutUs.html?idx=${idx}&id=${ids}&bg=${bg}`
			// } 
			else {
				url = `indexList.html?idx=${idx}&id=${ids}&bg=${bg}`
			}
			// 详情
			if (navId && (navId.slice(0, 3) === '43/' ||
				navId.slice(0, 2) === '1/' ||
				navId.slice(0, 2) === '2/' ||
				navId.slice(0, 2) === '3/' ||
				navId.slice(0, 2) === '4/' ||
				navId.slice(0, 2) === '5/' ||
				navId.slice(0, 2) === '6/' ||
				navId.slice(0, 2) === '7/' ||
				navId.slice(0, 2) === '9/')
			) {
				url = `member.html?idx=${idx}&id=${navId}&name=${name}&bg=${bg}`
			}
			// 头部一级导航
			contents = `<div class="nav-item">
                        <a href="${url}" target="${aTagTarget}"> ${title} </a>
                        </div>
                      <div class="nav-line" id="navLine"></div>`;
			$("#nav").append(contents);

			if (list[i].name) {
				// 底部一级导航
				footerList = `<div class="item-list">
							<p class="footer-item__title">
							<a href="${url}">${list[i].name}</a>
							</p>
							</div>`;
				$(".footer-box").append(footerList);
			}

		});

		for (let index = 0; index < list.length; index++) {
			// 底部二级导航
			if (list[index].typeOptionsId === 1) {
				let oldNavId = list[index].optionsId
				let parentId = Number(oldNavId)
				if (oldNavId && oldNavId.indexOf('/') !== -1) {
					parentId = oldNavId.split('/')[1]
				}

				$.get(
					"/api/admin/official/exc/informationCategory/list",
					{ parentId: parentId },
					function (res) {
						const list = res.data || [];
						$.each(list, function (i) {
							const navId = list[i].id;
							const id = that.tabId[index].optionsId;
							const bg = that.tabId[index].iconUrl;
							// const idx = that.tabId[index].sort;
							const idx = i + 1;
							const url = `indexList.html?idx=${idx}&id=${id}&subId=${navId}&bg=${bg}`;
							footerSub = `<p>
								<a href="${url}">${list[i].module}</a>
							</p>`;
							$(".item-list").eq(index).append(footerSub);
						});
					}
				);
			}
		}

		getConfig();
	},
});

function getConfig() {
	$.ajax({
		url: "/api/admin/official/exc/configWebsite",
		type: "GET",
		dataType: "json",
		success: function (res) {
			// 服务方式&关注我们
			const listHtml = `
        <div class="item-list">
          <p class="footer-item__title">服务方式</p>
          <p>
            <img src="/static/images/footer-icon-phone.png" alt="" />
            <span class="phone"></span>
          </p>
          <p>
            <img src="/static/images/footer-icon-mailbox.png" alt="" />
            <span class="email"></span>
          </p>
          <p>
            <img src="/static/images/footer-icon-location.png" alt="" />
            <span class="address"></span>
          </p>
        </div>
        <div class="item-list">
          <p class="footer-item__title">关注我们</p>
          <div class="footer-code">
            <div class="code-img"></div>
            <p>扫码关注</p>
          </div>
        </div>`;
			$(".footer-box").append(listHtml);
			$(".phone").append(res.data.tel);
			$(".email").append(res.data.email);
			$(".address").append(res.data.contactAddress);
			$(".copy-right").prepend(res.data.copyrightInformation);
			$(".record-num").append(res.data.recordNum);
			$("#web-title").append(res.data.websiteName);
			$("#home-name").append(res.data.indexName);

			let icon = "";
			icon += `<link rel="icon" href= ${res.data.iconUrl} />`;

			let keywordstext = "";
			keywordstext += `<meta name="Keywords" content= ${res.data.websiteName} />`;

			let description = "";
			description += `<meta name="Description" content= ${res.data.websiteDesc} />`;
			$("head").append(icon, keywordstext, description);

			let logo = "";
			logo += `<img class="logo col-2" src= ${res.data.logoUrl} style="height: 40px;object-fit: contain;" />`;
			$(".logo-box").prepend(logo);
			$('.logo-box').show()

			let qrCode = "";
			qrCode += `<img src= ${res.data.qrcodeUrl} />`;
			$(".code-img").append(qrCode);
		},
	});
}
